<template>
  <a
    ref="skipLink"
    href="#main-heading"
    class="skip-to-content"
  >
    Zum Hauptinhalt springen
  </a>
</template>

<script>
export default {
  name: 'ASkipToContent'
}
</script>

<style scoped>
.skip-to-content {
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%) translateY(-100%);
  opacity: 0;
  z-index: 999;
  transition: opacity 0.3s, transform 0.3s;
}

.skip-to-content:focus {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}
</style>
